import React, {useContext} from 'react'
import AppContext from '../appContext'
import LimeProgramLabInputRow from '../controllers/LimeProgramLabInputRow'
import MeasurementUnit from '../controllers/MeasurementUnit'
import {buildSoilDisplayColumns} from '../pages/liming/limeSoilUtils'

export interface SampleDataColumn {
    header: React.ReactNode
    row: (item: LimeProgramLabInputRow) => React.ReactNode
}

interface SampleDataOverlayProps {
    row: LimeProgramLabInputRow
    meq100gMode: boolean
    system: MeasurementUnit
    extraColumns?: SampleDataColumn[]
}

const SampleDataOverlay: React.FC<SampleDataOverlayProps> = ({row, meq100gMode, system, extraColumns}) => {
    const app = useContext(AppContext)
    const th = "px-2 py-1 text-left"
    const td = "px-2 py-1"
    // Shared canonical soil columns so this overlay stays in sync with the other lab-results tables.
    const columns = buildSoilDisplayColumns(system, meq100gMode)

    return (
        <div className="absolute top-0 left-0 right-0 overflow-x-auto bg-white/90 border-b border-gray-300 shadow-sm z-10">
            <table className="w-full text-xs">
                <thead>
                    <tr className="bg-gray-200/90">
                        <th className={th}>{app.word('reference_nr')}</th>
                        <th className={th}>{app.word('sample_depth')}</th>
                        {columns.map((c, i) => <th key={i} className={th}>{c.header}</th>)}
                        {extraColumns?.map((c, i) => <th key={`x${i}`} className={th}>{c.header}</th>)}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className={td}>{row.referenceNr || row.landName}</td>
                        <td className={td}>{app.word(row.sampleDepth)}</td>
                        {columns.map((c, i) => <td key={i} className={td}>{c.value(row)}</td>)}
                        {extraColumns?.map((c, i) => <td key={`x${i}`} className={td}>{c.row(row)}</td>)}
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default SampleDataOverlay
